import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BulletPointsResponse } from '../entities/speak-your-skills.model';
import { LerApiService } from './ler-api.service';

@Injectable({ providedIn: 'root' })
export class LerBulletPointsApiService extends LerApiService {
  loadBulletPoints(credentialUuid: string): Observable<BulletPointsResponse> {
    return this._get(`/v1/ler/credentials/${credentialUuid}/bullet_points`).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res) => this._handleError(res, true)),
    );
  }
}
